<template>
  <section class="in-layout">
    <v-toolbar
      class="header"
      color="green darken-2"
      dark
      flat
    >
      <v-container fluid>
        <v-layout align-center row>
          <ima-logo />
          <v-spacer />
          <navigation-header />
          <!--<notification-dropdown />-->
          <account-dropdown />
        </v-layout>
      </v-container>
    </v-toolbar>

    <div class="area px-4">
      <aside class="sidebar">
        <slot name="sidebar" />
      </aside>
      <!-- <navigation-breadcrumb v-if="breadcrumb !== false"/> -->
      <slot name="content" />
      <div class="">
        <slot name="list" />
      </div>
    </div>
    <contact-component/>
  </section>
</template>

<script>
import ContactComponent from '@/components/ContactComponent';
import ImaLogo from '@/components/base/ImaLogo';
import NavigationHeader from '@/components/base/NavigationHeader';
import AccountDropdown from '@/components/base/AccountDropdown';

export default {
  name: 'InLayout',
  components: {
    ImaLogo,
    ContactComponent,
    NavigationHeader,
    AccountDropdown,
  },
  props: ['breadcrumb'],
};
</script>

<style lang="scss">
  .in-layout {
    > .header {
      height: 6.1rem;
    }

    > .area {

      .header {
        > .title {
          & {
            position: relative;
            margin: .5rem 0 1rem 40px;
          }
        }
      }
    }
  }
  .list-tabs {
    > .v-tabs__bar {
      & {
        background: none;
      }

      .v-tabs__wrapper {
        z-index: 2;
        position: relative;
        overflow: visible;

        &:after {
          z-index: 3;
          display: block;
          position: absolute;
          left: 0;
          bottom: -15px;
          width: 100%;
          height: 15px;
          background: #fff;
          content: "";
          transition: bottom ease .5s;
          transition-delay: .15s;
        }
      }

      .v-tabs__item {
        & {
          position: relative;
          padding: .5rem 1.5rem;
          background: #e0e0e0;
          font-size: 1.2rem;
          border-radius: 3px 3px 0 0;
        }

        &.v-tabs__item--active {
          & {
            background: #fff;
            box-shadow: 0 3px 15px rgba(0,0,0,.20);
          }
        }
      }
    }

    > .v-tabs__items {
      & {
        overflow: visible;
      }

      .v-tabs__content {
        transition: none !important;
      }
    }
  }
</style>
